import store from '../store'
export default {
    /**
     * Register the service worker.
     */
    registerServiceWorker() {
        console.log('registerServiceWorker');
        if (!('serviceWorker' in navigator)) {
            console.log('Service workers aren\'t supported in this browser.')
            return
        }
        navigator.serviceWorker.register('service-worker.js')
            .then(() => this.init())
        //.then(() => this.initialiseServiceWorker())
    },

    async init() {
        this.findSubscription().then(sub => {
            if (sub === null) {
                console.log('no active subscription found on the client', sub);
                //this.notificationsEnabled = false

                // Ask permission and when granted, create new subscription
                Notification.requestPermission()
                    .then(result => {
                        console.log(result);
                        // if granted, create new subscription
                        if (result === 'granted') {
                            this.createSubscription()
                            //this.showGrantNotification()
                        } else {
                            console.log('User did not granted permission')
                        }
                    })
            } else {
                console.log('Active subscription found', JSON.stringify(sub));
                // retrieve user info from API
                //this.notificationsEnabled = true
                //this.subscription = sub
                this.addSubscription(sub)
            }
            //this.sendNotification()
        })
    },
    findSubscription() {
        console.log('get active service worker registration');
        return navigator.serviceWorker.ready
            .then(swreg => {
                console.log('haal active subscription op');
                this.serviceWorkerRegistation = swreg
                return this.getSubscription(this.serviceWorkerRegistation)
            })
    },
    getSubscription(swreg) {
        console.log('ask for available subscription');
        return swreg.pushManager.getSubscription()
    },
    async createSubscription() {
        let sw = await navigator.serviceWorker.ready
        let subscription = await this.subscribe(sw)
        this.addSubscription(subscription)
    },
    addSubscription(subscription) {
        //const p256dh = subscription.getKey('p256dh')
        //const auth = subscription.getKey('auth')

        let p256dh = JSON.parse(JSON.stringify(subscription)).keys.p256dh;
        let auth = JSON.parse(JSON.stringify(subscription)).keys.auth;

        const data = {
            endpoint: subscription.endpoint,
            p256dh: p256dh,//? btoa(String.fromCharCode.apply(null, new Uint8Array(p256dh))) : null,
            auth: auth //? btoa(String.fromCharCode.apply(null, new Uint8Array(auth))) : null,
        }

        console.log(data);
        var AddSubscriptionData = data
        store.dispatch('AddSubscription', { AddSubscriptionData }).then(result => {
            console.log(result);
        })
    },

    urlB64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    },

    async subscribe(swreg) {
        console.log('create new subscription for this browser on this device');
        // create new subscription for this browser on this device
        //const vapidPublicKey = process.env.VUE_APP_VAPID_PUBLIC_KEY
        const vapidPublicKey = 'BF-9DAjR4QAFiR8wU9Yb0TMxuhX5FTs9-uEeGZNq4OsY5I-munE2VDABXUEbcrF6nry4xUiMaa-jorWMvQchy1U'
        console.log(vapidPublicKey);
        const convertedVapidPublicKey = this.urlB64ToUint8Array(vapidPublicKey)

        let push = await swreg.pushManager.subscribe({
            userVisibleOnly: true,
            // This is for security. On the backend, we need to do something with the VAPID_PRIVATE_KEY
            // that you can find in .env to make this work in the end
            applicationServerKey: convertedVapidPublicKey
        })
        // return the subscription promise, we chain another then where we can send it to the server
        console.log(JSON.stringify(push));
        return push
    },

    showGrantNotification() {
        this.serviceWorkerRegistation.showNotification('Notifications granted', {
            body: 'Here is a first notification',
            icon: '/img/icons/android-chrome-192x192.png',
            image: '/img/autumn-forest.png',
            vibrate: [300, 200, 300],
            badge: '/img/icons/plint-badge-96x96.png',
        })
    },

    sendNotification(senderPerno, recieverPerno, RequestType, requestState) {
        var moment = require("jalali-moment");
        var date = moment()
            .locale("fa")
            .format("YYYY/MM/DD");

        var time = moment()
            .locale("fa")
            .format("hh:mm");

        /*if (!senderPerno) {
            senderPerno = store.state.auth.auth.username
            recieverPerno = store.state.auth.auth.username
            RequestType = 3
            requestState = 3
        }*/

        var SendNotificationParams = {
            senderPerno: senderPerno,//store.state.auth.auth.username,
            recieverPerno: recieverPerno,
            RequestType: RequestType,
            requestState: requestState,
            date: date,
            time: time,
        }

        store.dispatch('SendNotification', { SendNotificationParams }).then(result => {
            console.log(result);
        })
    },
    /**
     * https://github.com/Minishlink/physbook/blob/02a0d5d7ca0d5d2cc6d308a3a9b81244c63b3f14/app/Resources/public/js/app.js#L177
     *
     * @param  {String} base64String
     * @return {Uint8Array}
     */
    urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4)
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/')
        const rawData = window.atob(base64)
        const outputArray = new Uint8Array(rawData.length)
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i)
        }
        return outputArray
    }
}